import { EChartTimeseries } from "../../../components/EChartTimeseries.js";
import { useMemoizedBarSeries } from "../../../hooks/chart.js";
import { type SpecificUsageChartProps, UsageChartWrapper } from "./UsageChartWrapper.js";
import { IconCpu } from "@tabler/icons-react";
import { checkIsApproachingLimit } from "./utils/limits.js";
import { TieredPriceProductId } from "@project/common";
import { useProcessingUsage } from "./hooks/fetchUsages.js";
import { useProductNames } from "./hooks/productLabels.js";

export function ProcessingUsageChart({
  from,
  to,
  interval,
  apiKeyId,
  addToDetailedView,
}: SpecificUsageChartProps) {
  const {
    processingUsage,
    isLoadingProcessingUsage,
    isErrorProcessingUsage,
  } = useProcessingUsage({ from, to, interval, apiKeyId });

  const getName = useProductNames();
  const title = getName(TieredPriceProductId.TieredProcessing);
  const series = useMemoizedBarSeries(processingUsage, title);

  return (
    <UsageChartWrapper
      title={title}
      iconColor="info.5"
      icon={<IconCpu size={20} />}
      isLoading={isLoadingProcessingUsage}
      hasError={isErrorProcessingUsage}
      hasUsage={processingUsage.length > 0}
      addToDetailedView={addToDetailedView}
      isApproachingLimit={checkIsApproachingLimit(processingUsage, TieredPriceProductId.TieredProcessing)}
    >
      <EChartTimeseries series={series} />
    </UsageChartWrapper>
  );
};
